import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import Severity$1 from 'vscode/vscode/vs/base/common/severity';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { DialogsModel } from '../../../common/dialogs.js';
import { IWorkbenchEnvironmentService } from 'vscode/vscode/vs/workbench/services/environment/common/environmentService.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';

let DialogService = class DialogService extends Disposable {
    constructor(environmentService, logService) {
        super();
        this.environmentService = environmentService;
        this.logService = logService;
        this.model = this._register(( new DialogsModel()));
        this.onWillShowDialog = this.model.onWillShowDialog;
        this.onDidShowDialog = this.model.onDidShowDialog;
    }
    skipDialogs() {
        if (this.environmentService.isExtensionDevelopment && this.environmentService.extensionTestsLocationURI) {
            return true;
        }
        return !!this.environmentService.enableSmokeTestDriver;
    }
    async confirm(confirmation) {
        if (this.skipDialogs()) {
            this.logService.trace('DialogService: refused to show confirmation dialog in tests.');
            return { confirmed: true };
        }
        const handle = this.model.show({ confirmArgs: { confirmation } });
        return await handle.result;
    }
    async prompt(prompt) {
        if (this.skipDialogs()) {
            throw ( new Error(
                `DialogService: refused to show dialog in tests. Contents: ${prompt.message}`
            ));
        }
        const handle = this.model.show({ promptArgs: { prompt } });
        const dialogResult = await handle.result;
        return {
            result: await dialogResult.result,
            checkboxChecked: dialogResult.checkboxChecked
        };
    }
    async input(input) {
        if (this.skipDialogs()) {
            throw ( new Error('DialogService: refused to show input dialog in tests.'));
        }
        const handle = this.model.show({ inputArgs: { input } });
        return await handle.result;
    }
    async info(message, detail) {
        await this.prompt({ type: Severity$1.Info, message, detail });
    }
    async warn(message, detail) {
        await this.prompt({ type: Severity$1.Warning, message, detail });
    }
    async error(message, detail) {
        await this.prompt({ type: Severity$1.Error, message, detail });
    }
    async about() {
        if (this.skipDialogs()) {
            throw ( new Error('DialogService: refused to show about dialog in tests.'));
        }
        const handle = this.model.show({});
        await handle.result;
    }
};
DialogService = ( __decorate([
    ( __param(0, IWorkbenchEnvironmentService)),
    ( __param(1, ILogService))
], DialogService));

export { DialogService };
